import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { GAME_ROOMS } from '../../../screens/Home/constants';
import { checkDynamicGameRooms } from '../../../state/query/games/utils';
import AppBackgroundType from '../../../utils/AppBackgroundType';
import { ASSET_KEY, assetSource } from '../../../utils/assetSource';
var roomByPath = function roomByPath() {
  var rooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var path = arguments.length > 1 ? arguments[1] : undefined;
  var found = rooms === null || rooms === void 0 ? void 0 : rooms.find(function (r) {
    return r.urlPath === path;
  });
  return found ? [found] : [];
};
export var getAppBackgroundImage = function getAppBackgroundImage(_ref) {
  var type = _ref.type,
    backgroundPromo = _ref.backgroundPromo,
    promotionImagesUrl = _ref.promotionImagesUrl,
    _ref$customAppBackgro = _ref.customAppBackgrounds,
    customAppBackgrounds = _ref$customAppBackgro === void 0 ? {} : _ref$customAppBackgro,
    _ref$slotGames = _ref.slotGames,
    slotGames = _ref$slotGames === void 0 ? [] : _ref$slotGames,
    _ref$tableGames = _ref.tableGames,
    tableGames = _ref$tableGames === void 0 ? [] : _ref$tableGames,
    _ref$vipGames = _ref.vipGames,
    vipGames = _ref$vipGames === void 0 ? [] : _ref$vipGames,
    _ref$sportsGames = _ref.sportsGames,
    sportsGames = _ref$sportsGames === void 0 ? [] : _ref$sportsGames,
    _ref$favouriteGames = _ref.favouriteGames,
    favouriteGames = _ref$favouriteGames === void 0 ? [] : _ref$favouriteGames,
    _ref$gameRooms = _ref.gameRooms,
    gameRooms = _ref$gameRooms === void 0 ? [] : _ref$gameRooms;
  var isDynamicGameRoom = checkDynamicGameRooms();
  var CONFIG = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AppBackgroundType.VIP_GAMES, {
    games: isDynamicGameRoom ? roomByPath(gameRooms, GAME_ROOMS.VIP) : vipGames,
    assetKey: ASSET_KEY.VIP_BACKGROUND
  }), AppBackgroundType.TABLE_GAMES, {
    games: isDynamicGameRoom ? roomByPath(gameRooms, GAME_ROOMS.TABLES) : tableGames,
    assetKey: ASSET_KEY.LOBBY_BACKGROUND
  }), AppBackgroundType.SPORTS_GAMES, {
    games: isDynamicGameRoom ? roomByPath(gameRooms, GAME_ROOMS.SPORTS) : sportsGames,
    assetKey: ASSET_KEY.LOBBY_BACKGROUND
  }), AppBackgroundType.FAVOURITES, {
    games: isDynamicGameRoom ? roomByPath(gameRooms, GAME_ROOMS.FAVOURITES) : favouriteGames,
    assetKey: ASSET_KEY.LOBBY_BACKGROUND
  }), AppBackgroundType.NORMAL, {
    games: isDynamicGameRoom ? roomByPath(gameRooms, GAME_ROOMS.SLOTS) : slotGames,
    assetKey: ASSET_KEY.LOBBY_BACKGROUND
  });
  var _ref2 = CONFIG[type] || CONFIG[AppBackgroundType.NORMAL],
    _ref2$games = _ref2.games,
    games = _ref2$games === void 0 ? [] : _ref2$games,
    assetKey = _ref2.assetKey;
  if (promotionImagesUrl) {
    var matched = games === null || games === void 0 ? void 0 : games.find(function (game) {
      return Object.prototype.hasOwnProperty.call(customAppBackgrounds, game.room_id);
    });
    if (matched) {
      return "".concat(promotionImagesUrl, "/").concat(customAppBackgrounds[matched.room_id]);
    }
    if (backgroundPromo) {
      return "".concat(promotionImagesUrl, "/").concat(backgroundPromo);
    }
  }
  return assetSource(assetKey);
};